import { Link } from 'react-router-dom';

const quickLinks = [
  { label: 'Inicio', path: '/' },
  { label: 'Nosotros', path: '/nosotros' },
  { label: 'Servicios', path: '/servicios' },
  { label: 'Contacto', path: '/contacto' },
];

const servicesLinks = [
  { label: 'Medicina General', path: '/servicios' },
  { label: 'Emergencias 24/7', path: '/servicios' },
  { label: 'Pediatría', path: '/servicios' },
  { label: 'Ginecología', path: '/servicios' },
  { label: 'Cirugía General', path: '/servicios' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50 relative overflow-hidden">
      <div className="absolute inset-0 texture-dots-light opacity-20" />
      <div className="absolute -top-24 right-10 w-72 h-72 rounded-full bg-primary-600/20 blur-3xl" />

      <div className="relative w-full px-4 md:px-8 lg:px-12 pt-16 md:pt-20 pb-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 md:gap-8 mb-12 md:mb-16">
            {/* Brand */}
            <div className="lg:col-span-4">
              <div className="flex items-center gap-3 mb-5">
                <img
                  src="https://static.readdy.ai/image/5774bb29582c40f5252e7d37d3c89ae3/8954a27987ec9b2c6f4d9397aaa9290f.png"
                  alt="Clínica Tarija Vitalmedic SRL"
                  className="h-11 w-auto"
                />
                <div>
                  <span className="font-heading text-lg font-bold">Vital<span className="text-primary-400">medic</span></span>
                  <p className="text-[10px] text-background-300">Clínica Tarija SRL</p>
                </div>
              </div>
              <p className="text-sm text-background-300 leading-relaxed mb-6 max-w-sm">
                Comprometidos con la salud de las familias tarijeñas. Atención médica de calidad, las 24 horas del día.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/profile.php?id=100076219839197"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-50/10 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-lg" />
                </a>
                <a
                  href="https://wa.me/59177173439"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-50/10 text-background-200 hover:bg-accent-500 hover:text-secondary-950 transition-all cursor-pointer"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line text-lg" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-2">
              <h4 className="font-heading text-base font-semibold mb-5">Enlaces</h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.path + link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="lg:col-span-3">
              <h4 className="font-heading text-base font-semibold mb-5">Servicios</h4>
              <ul className="space-y-3">
                {servicesLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-accent-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="lg:col-span-3">
              <h4 className="font-heading text-base font-semibold mb-5">Contacto</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-500 flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-sm" />
                  </div>
                  <span className="text-sm text-background-300 leading-relaxed">
                    Junín 1152, atrás del Hospital Regional San Juan de Dios, Tarija
                  </span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-500 flex-shrink-0 mt-0.5">
                    <i className="ri-phone-line text-sm" />
                  </div>
                  <a href="tel:+59177173439" className="text-sm text-background-300 hover:text-accent-500 transition-colors cursor-pointer">
                    77173439
                  </a>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-500 flex-shrink-0 mt-0.5">
                    <i className="ri-time-line text-sm" />
                  </div>
                  <span className="text-sm text-background-300">
                    24 horas, 7 días a la semana
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/10 pt-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
              <p>© Clínica Vitalmedic Tarija SRL. Todos los derechos reservados.</p>
              <p>Tarija, Bolivia</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}